import { configureStore } from "@reduxjs/toolkit"
import itemsSlice from "./itemsSlice";
import { combineReducers } from "@reduxjs/toolkit";
import bagSlice from "./bagSlice";
import shopSlice from "./shopSlice";
import allItemsSlice from "./allItemsSlice";
import deliveryCitySlice from "./deliveryCitySlice";

const reducer = combineReducers({
  // here we will be adding reducers
    
    items: itemsSlice.reducer,
    bag: bagSlice.reducer,
    shop : shopSlice.reducer,
    allItems : allItemsSlice.reducer, 
    deliveryCity : deliveryCitySlice.reducer,
   
})
const amalStore = configureStore({
    reducer,
});
export default amalStore;